/*
 * Notification that the teacher has archived assignment(s).
 */
import {plural, t} from "@lingui/core/macro";
import * as React from "react";

import BaseToastNotification from "../components/base-toast-notification.tsx";

export default ({
    successCount,
    failedCount,
    studentListName,
    isChildAssignmentsClassroom,
}: {
    successCount: number;
    failedCount: number;
    studentListName?: string;
    isChildAssignmentsClassroom: boolean;
}): React.ReactElement => {
    if (successCount === 0) {
        return (
            <BaseToastNotification isError={true}>
                {plural(failedCount, {
                    one: "Oops! Looks like deleting # assignment failed. Please try again!",
                    other: "Oops! Looks like deleting # assignments failed. Please try again!",
                })}
            </BaseToastNotification>
        );
    }

    if (isChildAssignmentsClassroom) {
        return (
            <BaseToastNotification>
                {failedCount
                    ? t`You deleted ${successCount} assignment(s) from ${studentListName} but looks like deleting ${failedCount} assignment(s) failed. Please try again.`
                    : plural(successCount, {
                          one: `You deleted # assignment from ${studentListName}.`,
                          other: `You deleted # assignments from ${studentListName}.`,
                      })}
            </BaseToastNotification>
        );
    }

    return (
        <BaseToastNotification>
            {failedCount
                ? t`You deleted ${successCount} assignment(s) from your class ${studentListName} but looks like deleting ${failedCount} assignment(s) failed. Please try again.`
                : plural(successCount, {
                      one: `You deleted # assignment from your class ${studentListName}.`,
                      other: `You deleted # assignments from your class ${studentListName}.`,
                  })}
        </BaseToastNotification>
    );
};
